import React from 'react'
import './About.css';
import Header from '../../Header';
import Navbar from '../../Navbar';
import Footers from '../../Footers';
import NewsletterSection from '../../NewsletterSection';
import LatestTestimonials from '../../LatestTestimonials';
import mainImg from '../services-images/about-img.png';
import leafRight from '../services-images/bg-left-about.png';
import herbalImg from '../services-images/why-choose.png';
import mission from '../services-images/v1.webp';
import vision from '../services-images/v2.webp';
import bread from '../services-images/bredcrumb-bg.jpg';

const valuesData = [
  {
    icon: '',
    title: ' 100% Pure & Natural',
    description: 'Shilajit delivers only pure, resin-form Shilajit with no added chemicals, fillers, or preservatives. It s carefully processed to retain its natural potency, ensuring that you receive maximum health benefits with every dose. Authentic, unadulterated, and effective — just the way nature intended.'
  },
  {
    icon: '',
    title: 'Sourced from the Himalayas',
    description: 'We source our Shilajit from altitudes above 16,000 ft in the untouched Himalayan ranges. This high-altitude environment ensures purity and high mineral concentration. The pristine conditions give our Shilajit its rich, dark texture and powerful healing properties trusted by generations.'
  },
  {
    icon: '',
    title: 'Lab Tested for Safety ',
    description: 'Every batch is third-party lab tested to ensure it’s free from heavy metals, contaminants, and harmful microbes. We also verify high fulvic acid content, which is key to Shilajit’s effectiveness. Our tests guarantee a safe, potent supplement you can trust daily.'
  },
  {
    icon: '',
    title: 'Fast & Secure Delivery',
    description: 'Experience quick, reliable shipping across India with secure, tamper-proof packaging. We ensure hygienic handling and real-time tracking so your order reaches you safely and on time. Wellness made simple, right to your doorstep.'
  }
];

export default function About() {
  return (
    <div>
      <Header />
      <Navbar />
      <img src={bread} alt="bread"  className="bread" />
      {/* about */}
      <div className="about-section">
        <div className="about-left">
          <div className="image-wrapper">
            <img src={mainImg} alt="Main" className="main-img" />
            <div className="experience-box">
              <span className="years">10</span>
              <span className="text">Years of Experience</span>
            </div>
          </div>
        </div>

        <div className="about-right">
          <p className="subheading">About Us</p>
          <h2>
            The Natural Way To Achieving<br />
            Balance And Optimal Health
          </h2>
          <p className="description">
            We are a wellness-driven brand dedicated to unlocking the power of nature through the ancient wisdom of Ayurveda. At the heart of our journey lies one of nature’s most potent gifts — Pure Himalayan Shilajit. We believe in holistic healing that begins from within, and Shilajit is the core of our mission to bring strength, vitality, and balance into modern life.
          </p>
       
        </div>

        <img src={leafRight} alt="Leaf" className="leaf-decor" />
      </div>
      {/* chose */}
      <div className="why-section">
        <div className="why-left">
          <p className="why-subtitle">Why Choose Us</p>
          <h2 className="why-title">
            Pure Power of Shilajit — Backed by Nature & Science
          </h2>
          <p className="why-text">
            At the heart of our wellness philosophy lies premium-grade Shilajit, harvested from the pristine Himalayan mountains. We combine ancient Ayurvedic wisdom with modern research to bring you potent, pure.        </p>

          <div className="why-feature">
            <span className="icon">✔️</span>
            <div>
              <h4>100% Pure & Natural</h4>
              <p> Shilajit delivers only pure, resin-form Shilajit with no added chemicals, fillers, or preservatives.</p>
            </div>
          </div>

          <div className="why-feature">
            <span className="icon">✔️</span>
            <div>
              <h4>Sourced from the Himalayas</h4>
              <p>We source our Shilajit from altitudes above 16,000 ft in the untouched Himalayan ranges. </p>
            </div>
          </div>
        </div>


        <div className="why-right">
          <div className="image-wrapper">
            <img src={herbalImg} alt="Herbal" className="herbal-img" />
          </div>
        </div>
      </div>
      {/* mission */}
      <div className="our-mission">
        <div className="mission-left">
          <div className="image-wrapper-mission">
            <img src={mission} alt="Main" className="main-img" />

          </div>
        </div>

        <div className="about-right-mission">
          <p className="subheading-mission">OUR MISSION</p>

          <p className="description-mission">
            Our mission at --- is to be an essential part of your well-being by offering authentic, thoughtfully crafted Ayurvedic products. We’re committed to enhancing holistic health, caring for every family member—from infants to the elderly. Our goal is to share the timeless wisdom of Ayurveda with the world, making natural healing accessible to everyone. We strive to be the most trusted Ayurvedic brand, providing only 100% genuine, high-quality products. At ----, our purpose is simple: to deliver excellence and bring the healing power of Ayurveda to every home, improving lives naturally and compassionately.          </p>
        
        </div>

      </div>
      {/* vision */}
      <div className="our-mission">
       
        <div className="about-right-mission">
          <p className="subheading-mission">OUR VISION</p>

          <p className="description-mission">
            At ----, we aim to become the most trusted name in Ayurveda by creating high-quality products that blend ancient wisdom with modern innovation. We believe that the answers to today’s health challenges lie in the time-honoured principles of Ayurveda, passed down through generations. Our vision is to lead a global revival of Ayurveda, where its natural remedies are embraced as solutions for modern ailments. In the next decade, we aspire to set the gold standard for Ayurvedic excellence, blending its rich traditions with today’s healthcare science to create harmony for body, mind, and spirit.       </p>
        </div>
        <div className="mission-left">
          <div className="image-wrapper-mission">
            <img src={vision} alt="Main" className="main-img" />

          </div>
        </div>
      </div>
      <LatestTestimonials />
      <NewsletterSection />
      <Footers />
    </div>
  );
}
